import React from "react";
import moment from "moment-timezone";
import { useSelector } from "react-redux";

import { StyledTable } from "../../../../useGeneralStyles";
import { ContainerWithLoader } from "../../../../components/ui";

import EditNote from "./components/EditNote";

interface IProps {
  fetchFundedTraderNotes: () => Promise<void>;
}

const FundedTraderNotes: React.FC<IProps> = ({ fetchFundedTraderNotes }) => {
  const { notes } = useSelector((state) => state.fundedTrader);
  const { isLoading, data } = notes;

  return (
    <ContainerWithLoader isLoading={isLoading} report={data} noResultsMessage="There are no notes">
      <StyledTable>
        <tbody>
          {data.map(({ id, note, create_date, admin_account }) => (
            <React.Fragment key={id}>
              <tr style={{ textAlign: "right" }}>
                <td>
                  <p style={{ margin: 0 }}>{moment(create_date).tz("America/Chicago").format("YYYY-MM-DD HH:mm")}</p>
                  <p style={{ margin: 0 }}>{admin_account.name}</p>
                </td>
              </tr>
              <tr style={{ borderBottom: "1px solid rgba(0,0,0,.2)" }}>
                <EditNote
                  fetchFundedTraderNotes={fetchFundedTraderNotes}
                  note_id={id}
                  note={note}
                />
              </tr>
            </React.Fragment>
          ))}
        </tbody>
      </StyledTable>
    </ContainerWithLoader>
  );
};

export default FundedTraderNotes;
